import React, { useEffect, useState } from 'react';
import { View, Pressable } from 'react-native';
import { useRouter } from 'expo-router';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { getStorage } from '@/store/storage';

export default function WorkTaskStartedNotice({ source, taskId, autoDismiss = false, onOpenSource }) {
  const router = useRouter();
  const { colors } = useTheme();
  const storageKey = taskId ? `gab.workTaskNotice.dismissed.${taskId}` : null;
  const [visibility, setVisibility] = useState({ key: null, dismissed: false });
  useEffect(() => {
    let active = true;
    if (autoDismiss) {
      setVisibility({ key: storageKey, dismissed: true });
      if (storageKey) Promise.resolve().then(() => getStorage().setItem(storageKey, '1')).catch(() => {});
      return;
    }
    if (!storageKey) { setVisibility({ key: null, dismissed: false }); return; }
    Promise.resolve().then(() => getStorage().getItem(storageKey))
      .then(value => { if (active) setVisibility({ key: storageKey, dismissed: value === '1' }); })
      .catch(() => { if (active) setVisibility({ key: storageKey, dismissed: false }); });
    return () => { active = false; };
  }, [storageKey, autoDismiss]);
  const dismiss = () => {
    setVisibility({ key: storageKey, dismissed: true });
    if (storageKey) Promise.resolve().then(() => getStorage().setItem(storageKey, '1')).catch(() => {});
  };
  if (autoDismiss || !source?.conversationId || visibility.key !== storageKey || visibility.dismissed) return null;
  return <View testID="work-task-started-notice" style={{ margin: 8, padding: 15, borderRadius: 13,
    backgroundColor: colors.solid_color_secondary, flexDirection: 'row', alignItems: 'flex-start', gap: 10 }}>
    <Icon name="arrow-up-right-from-square" size={14} color={colors.text_color_secondary} />
    <View style={{ flex: 1, gap: 5 }}>
      <Text size="s" weight="bold">Started a separate work chat for this request</Text>
      <Text size="xs" color="secondary">The new task has its own plan. Your previous work is saved in the original chat.</Text>
      <Pressable accessibilityRole="link" accessibilityLabel="Open original work chat"
        onPress={() => onOpenSource ? onOpenSource() : router.push(`/c/${source.conversationId}`)} style={{ alignSelf: 'flex-start', paddingTop: 3 }}>
        <Text size="xs" weight="bold">Open original chat →</Text>
      </Pressable>
    </View>
    <Pressable accessibilityRole="button" accessibilityLabel="Dismiss new work chat notice"
      onPress={dismiss} hitSlop={8} style={({ pressed }) => ({ width: 28, height: 28,
        alignItems: 'center', justifyContent: 'center', borderRadius: 6, opacity: pressed ? 0.55 : 1 })}>
      <Icon name="xmark" size={15} color={colors.text_color_secondary} />
    </Pressable>
  </View>;
}
